/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import users from './users'
import order from './order'
import consulting from './consulting'
import circular from './circular'
import blog from './blog'
import other from './public'
import product from './product'
import ticket from './ticket'
import advertisement from './advertisement'
import customs from './customs'
import agent from './agent'
import merchant from './merchant'
import wallet from './wallet'
import currency from './currency'

// Array of sections
export default [...users, ...product, ...consulting, ...advertisement, ...circular, ...blog, ...ticket, ...customs, ...agent, ...merchant, ...wallet, ...currency, ...other]
